import styled from 'styled-components'

const PhoneNumberContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 15px;
`

export default PhoneNumberContainer
